"use client";

import { useContext } from "react";

import { MediaContext } from "../providers/MediaProvider/MediaProvider";

export const usePlayer = () => useContext(MediaContext);
